module.exports = __webpack_public_path__ + "static/media/2022-january-youtube.07ebb2cf.jpg";